import instance from 'api';
import { IRealEstate } from './interfaces';

export const getRealEstates = (includeDeleted: boolean, includeUnserved: boolean) => {
  return instance()
    .post<IRealEstate[]>('/dictionary/realEstates', { includeDeleted, includeUnserved })
    .then((response) => response.data);
};

export const getEstateStaff = (realEstateGuid: string) => {
  return instance()
    .post('/realEstateStaff/list', { realEstateGuid })
    .then((response) => response.data);
};

export const saveEstateStaff = (positionId: number, userId: string, realEstateGuid: string) => {
  return instance()
    .post<void>('/realEstateStaff/save', { positionId, userId, realEstateGuid })
    .then((response) => response.data);
};

export const deleteEstateStaff = (positionId: number, userId: string, realEstateGuid: string) => {
  return instance()
    .post<void>('/realEstateStaff/delete', { positionId, userId, realEstateGuid })
    .then((response) => response.data);
};

export const updateRealEstateName = (data: { realEstateGuid: string; realEstateName: string }) => {
  return instance()
    .post<void>('/dictionary/updateRealEstateName', data)
    .then((response) => response.data);
};

export const updateRealEstateAddress = (data: { realEstateGuid: string; addressRu?: string, addressKk?: string }) => {
  return instance()
    .post<void>('/dictionary/updateRealEstateAddress', data)
    .then((response) => response.data);
};

export const syncRealEstate = () => {
  return instance()
    .post<void>('/sync/syncRealEstate', {})
    .then((response) => response.data);
};

export const syncRooms = (realEstateGuid: string) => {
  return instance()
    .post<void>('/sync/syncRooms', { realEstateGuid })
    .then((response) => response.data);
};

export const loadTempTokenBigApp = () => {
  return instance()
    .post<{ token: string }>('/users/tempTokenBigApp')
    .then((response) => response.data);
};

export const updateIsChecklist = (realEstateGuid: string, isCheckList: boolean) => {
  return instance()
    .post('/realEstate/updateIsCheckList', { realEstateGuid, isCheckList })
    .then((response) => response.data);
};

export const updateIsNoneService = (realEstateGuid: string, isNoneService: boolean) => {
  return instance()
    .post('/realEstate/updateIsNoneService', { realEstateGuid, isNoneService })
    .then((response) => response.data);
};
